import React from "react";
import back from "../../assets/back.png";
import { Colors } from "../../utils/colors";
import { BottomSheet } from "../bottomSheet/BottomSheet";
import { PlayersList } from "../playersList/PlayersList";
import { SearchBar } from "../searchBar/SearchBar";
import { TCText } from "../TCText/TCText";
import { observer } from "mobx-react-lite";
import {
  useCourtBookingStore,
  useSectionStore,
  useSelectCircleStore,
} from "../../stores/StoreContext";
import { Button } from "../button/Button";
import LoadingSpinner from "../loadingSpinner/LoadingSpinner";
import LoadingIndicator from "../loadingIndicator/LoadingIndicator";

type props = {
  showBottomSheet: boolean;
  closeBottomSheet: () => void;
};

export const SelectPlayerBottomSheet: React.FC<props> = observer(
  ({ showBottomSheet, closeBottomSheet }) => {
    const selectCircleStore = useSelectCircleStore();
    const sectionStore = useSectionStore();
    const courtBookingStore = useCourtBookingStore();

    const checkAndExpandPaymentSection = () => {
      if (
        selectCircleStore.selectedPlayers.length ===
        courtBookingStore.totalPlayersToSelect
      ) {
        sectionStore.onExpandPaymentSection();
      } else {
        selectCircleStore.isAIWillSelectPlayerModalVisible = true;
      }
    };

    return (
      <BottomSheet
        isVisible={showBottomSheet}
        onClose={() => closeBottomSheet()}>
        <div
          style={{
            height: "90vh",
            display: "flex",
            flexDirection: "column",
          }}>
          <div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}>
              <div
                onClick={() => {
                  checkAndExpandPaymentSection();
                  closeBottomSheet();
                }}
                style={{ cursor: "pointer" }}>
                <img src={back} alt="back" width={11} height={18} />
              </div>
              <TCText
                style={{
                  fontWeight: 600,
                  fontSize: 16,
                  flex: 1,
                  alignSelf: "center",
                  textAlign: "center",
                }}
                value="Select friends"
              />
              <Button
                text="Done"
                onPress={() => {
                  checkAndExpandPaymentSection();
                  closeBottomSheet();
                }}
                btnStyle={{
                  paddingLeft: 40,
                  paddingRight: 40,
                  height: 40,
                  position: "absolute",
                  right: 10,
                  backgroundColor: Colors.darkBrown,
                }}
                textStyle={{
                  color: "white",
                  fontWeight: 600,
                  fontSize: 14,
                }}
              />
            </div>
            <TCText
              style={{
                fontWeight: 600,
                fontSize: 18,
                flex: 1,
                marginTop: 20,
                marginBottom: 10,
              }}
              value="Search"
            />
            <SearchBar
              onSearch={(value) => selectCircleStore.setFilteredName(value)}
            />
          </div>
          <div
            style={{
              flex: 1,
              overflowY: "auto",
              msOverflowStyle: "none" /* IE and Edge */,
              scrollbarWidth: "none" /* Firefox */,
            }}>
            <PlayersList players={selectCircleStore.getPlayersList() ?? []} />
          </div>

          {selectCircleStore.isLoading ? (
            selectCircleStore.getPlayersList()?.length ? (
              <div style={{ display: "flex", justifyContent: "center" }}>
                <LoadingSpinner loading={selectCircleStore.isLoading} />
              </div>
            ) : (
              <LoadingIndicator loading={selectCircleStore.isLoading} />
            )
          ) : null}
        </div>
      </BottomSheet>
    );
  }
);
